import API from "../../api";
import * as actionTypes from "./actionTypes";

const showLoader = () => ({ type: actionTypes.SHOW_CONTACT_LOADER });
const hideLoader = () => ({ type: actionTypes.HIDE_CONTACT_LOADER });

export const send = (info) => (dispatch) => {
  dispatch(showLoader());

  API.contacts.send(
    info,
    (response) => {
      dispatch(hideLoader());
      setTimeout(() => (window.location.href = "/"), 4000);
      dispatch(contactSent(response));
    },
    (error) => {
      dispatch(hideLoader());
      setTimeout(() => (window.location.href = "/"), 4000);
      dispatch(contactSendFailed(error));
    }
  );
};

const contactSent = (response) => ({
  type: actionTypes.CONTACT_SENT,
  response,
});
const contactSendFailed = (error) => ({
  type: actionTypes.CONTACT_SEND_FAILED,
  error,
});



// WEBPACK FOOTER //
// ./src/store/contacts/actions.js